import {createSlice} from '@reduxjs/toolkit';

const taxConfigsSlice = createSlice({
    name: 'taxConfigs',
    initialState: [],
    reducers: {
        setTaxConfigs: (_, action) => action.payload,
        addTaxConfig: (state, action) => [...state, action.payload],
        updateTaxConfigById: (state, action) =>
            state.map(c => c.id === action.payload.id ? action.payload : c),
        removeTaxConfigById: (state, action) =>
            state.filter(c => c.id !== action.payload),
    },
    selectors: {
        selectTaxConfigs: (state) => state,
    },
});

export const {setTaxConfigs, addTaxConfig, updateTaxConfigById, removeTaxConfigById} = taxConfigsSlice.actions;
export const {selectTaxConfigs} = taxConfigsSlice.selectors;
export const {reducer} = taxConfigsSlice;
